import { gql } from '@apollo/client';

export const UpdateDefinitionPage = gql`
mutation UpdateDefinitionPage($updateDefinitionPageId: ID!, $content: contentDefinitionPage!) {
  updateDefinitionPage(id: $updateDefinitionPageId, content: $content) {
    status
  }
}
`;